import './validation.js';

let searchResultFilter = {};

(function (donationForm) {
    var paywayFrame = null;
    $(document).ready(function () {
        $(document).on("change", "#FundId", function (e) {
            $("#DonationFund").val($(this).find(":selected").text());
            let paymentOptionsSelect = $("#PaymentOptionId");
            paymentOptionsSelect.find("option").not(":first-child").remove();
            let selectedFundOption = $("#FundId option:selected");
            let paymentOptions = selectedFundOption.data("paymentoptions");
            if (!paymentOptions) return;

            paymentOptions.forEach((paymentOption) => {
                let option = 
                paymentOptionsSelect.append(`<option value="${paymentOption.id}"
                    data-is-creditcard="${paymentOption.isCreditCard}"
                    data-merchantid-reference="${paymentOption.merchantReference}">
                        ${paymentOption.name}
                    </option>`)
            });

            let fundId = $(this).val();
            if (fundId && fundId != "-1") {
                $(".js-paymentoptions-wrapper").show();
            } else {
                $(".js-paymentoptions-wrapper").hide();
                $(".js-payway-wrapper").hide();
            }
            paymentOptionsSelect.trigger("change");
        });

        $(document).on("change", "#PaymentOptionId", function (e) {
            var selectedOption = $(this).find(":selected");
            if (selectedOption.length < 0 || selectedOption.val() == "-1") {
                $(".js-payway-wrapper").hide();
                return;
            }

            $(".js-payway-wrapper").show();
            
            if (paywayFrame !== null) {
                paywayFrame.destroy();
            }

            var paymentType = selectedOption.data("isCreditcard") === true ? 'card' : 'bank';
            var merchantId = selectedOption.data("merchantidReference");

            $('.js-merchant-id').val(merchantId);
            $('.js-payment-type').val(paymentType);
            $('.js-single-use-token').val('');

            var style = paymentType === "card" ? { // card styling
                'div.payway-card': {
                    'background-color': '#404040',
                    'border-radius': '0em'
                },
                '.payway-card label': { 'color': 'white' },
                '.payway-card legend': { 'color': 'white' },
                '.payway-card input': { 'color': '#202020' },
                '.payway-card select': { 'color': '#202020' }
            } : { // bank styling
                'div.payway-account': {
                    'background-color': '#404040',
                    'border-radius': '0em'
                },
                '.payway-account label': { 'color': 'white' },
                '.payway-account input': { 'color': '#202020' }
            };


            style = {}; // reset styling to default for now

            if (paymentType.length > 0) {
                paywayFrame = payway[paymentType === "card" ? 'createCreditCardFrame' : 'createBankAccountFrame']({
                    publishableApiKey: publishableApiKey,
                    onValid: function () {
                        paywayFrame.getToken(function (err, data) {
                            $('.js-single-use-token').val(data.singleUseTokenId);
                            $('.js-donation-form').valid();
                        });
                    },
                    onInvalid: function () {
                        $('.js-single-use-token').val('');
                        $('.js-donation-form').valid();
                    },
                    style: style,
                    tokenMode: 'callback'
                }, function (err, frame) {
                    paywayFrame = frame;
                });
            }
        })

        if ($('.js-donation-form').length) {
            $('.js-donation-form').submit(function (e) {
                e.preventDefault();
                let $form = $(this);
                $("#IsAnonymous").val($("#Anonymous_yes").is(":checked"));
                if ($form.valid()) {
                    $form.find("input[type='submit']").prop("disabled", true).css("cursor", "wait");
                    $.ajax({
                        method: $form.attr("method"),
                        url: $form.attr("action"),
                        data: $form.serialize(),
                        success: function (data) {
                            $form.html(data);
                            $("#FundId").trigger("change");
                            $("#PaymentOptionId").trigger("change");
                            // reinitialise reCaptcha
                            if ($form.find(".g-recaptcha").length && grecaptcha) {
                                let recaptchaElement = $form.find(".g-recaptcha");                                
                                grecaptcha.render(recaptchaElement.attr("id"), {
                                    'sitekey': recaptchaElement.data("sitekey")
                                });
                            }
                        },
                        error: function (data) {
                            $form.find("input[type='submit']").prop("disabled", false).css("cursor", "");
                        },
                        dataType: "html"
                    });
                }
            });
        }
    });

})(searchResultFilter);
